export { SharedSocial } from "./social-shared";
